<template>
    <div class="scaleslider-wrapper" :class="[hideMarks ? 'hide-marks' : '']">
        <ValidationProvider :rules="rules" v-slot="v">
            <div class="scaleslider-external">
                <div class="flex">
                    <div class="flex-1 scaleslider-label" v-if="label" v-html="label"></div>
                    <div v-if="hint">
                        <HintComponent :hint="hint" />
                    </div>
                </div>
                <div :class="[includePadding ? 'px-6' : '', longLabels ? 'long-labels' : '']">
                    <vue-slider
                        v-model="content"
                        :adsorb="true"
                        :data="data"
                        data-value="value"
                        data-label="label"
                        dotSize="20"
                        height="2px"
                    >
                        <template v-slot:label="{ active, label }">
                            <div :class="['vue-slider-mark-label', { active }, {}]">{{ label }}</div>
                        </template>
                    </vue-slider>
                </div>
            </div>
        </ValidationProvider>
    </div>
</template>

<script>
import { ValidationProvider } from "vee-validate";
import HintComponent from "@components/misc/HintComponent";
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/antd.css";

export default {
    name: "ScaleSliderComponent",
    props: {
        value: { default: "" }, // value of the input
        data: { type: Array, default: [] }, // array of options
        label: { type: String, default: "" }, // text used for the top of this input
        hint: { type: String, default: "" }, // hint component text
        rules: { type: String, default: "required" }, // The validation rules set on the input. See VeeValidate for available rules
        hideMarks: { type: Boolean, default: true },
        includePadding: { type: Boolean, default: false },
        longLabels: { type: Boolean, default: false },
    },
    components: {
        ValidationProvider,
        HintComponent,
        VueSlider,
    },
    computed: {},
    data: function () {
        return {
            content: this.value,
        };
    },
    methods: {},
    watch: {
        content(value) {
            this.content = value;
            this.$emit("input", this.content);
            this.$emit("change", this.content);
        },
        value(value) {
            // Used to detect hydration
            this.content = value;
        },
    },
};
</script>
